/**
 * Constantes do índice "Artefatos desta conversa" (`chat-indice-artefatos.vue`
 * as re-exporta — os consumidores continuam importando do componente).
 * Extraídas para manter o `.vue` abaixo do teto de 500 linhas (I-15 do PR #2261).
 */
export const VISOES_DO_INDICE = Object.freeze({
  // Régua de tiles (40px, `LARGURA_DA_REGUA`) — o estado MÍNIMO do índice: é
  // o que a tela mostra quando não cabe menu ao lado do trilho E quando o
  // usuário minimizou (preferência). São só estas três visões desde
  // 14/09/2026 (decisão do usuário).
  compacta: 'compacta',
  completa: 'completa',
  condensada: 'condensada',
})
// A densidade do MENU (ao expandir da régua). Fixo: sem o botão de densidade
// não há escolha do usuário para persistir.
export const VISAO_ABERTA_PADRAO = VISOES_DO_INDICE.condensada
// Preferência de RÉGUA: presente (`'1'`) = nasce na régua mesmo com faixa;
// ausente = menu se cabe. Minimizar grava; expandir apaga.
export const CHAVE_DA_REGUA_NO_STORAGE = 'iaChatIndiceArtefatosRegua'
export const MARCA_DE_REGUA = '1'

// Sem medida, a condensada segue o conteúdo entre 180 e 240 (as
// `$largura-minima/maxima-condensada` do `<style>`). Com a faixa livre ao
// lado do trilho medida (`larguraMaxima`, do `messages.vue`): faixa ≥ PISO →
// menu condensado com largura FIXA `clamp(PISO, faixa, teto)`; faixa < PISO
// (inclusive 0, trilho ocupando o container) → a régua `compacta`. O piso é
// o menor menu ainda legível — ícone + 6-7 letras + "…". 128 e não 140: a
// 1920px com a lateral ABERTA (o caso do usuário) a faixa mede 136px, e o
// menu tem de caber ali (medido em 14/09/2026).
export const LARGURA_MAXIMA_DO_CARTAO = 240
export const PISO_DO_CARTAO_CONDENSADO = 128
// A régua de ícones (print de referência do usuário, 14/09/2026; tile e
// ícone reduzidos no mesmo dia — "o tile de 32 com wash está grande"): tile
// de 28px (proporção do menu: ícone 16) + 6px de respiro de cada lado.
export const LARGURA_DA_REGUA = 40
export const LADO_DO_TILE_DA_REGUA = 28
export const GAP_ENTRE_TILES_DA_REGUA = 8
// ★ O botão de expandir/recolher fica no MESMO ponto da tela nas duas
// visões (pedido do usuário, 14/09/2026: alternar sem mover o mouse). Os
// dois cartões são ancorados à direita da casca, então o botão (20px) fica
// a `direita` px da borda interna e `cima` px do topo em ambos: na régua é
// o botão centrado nos 40px de `border-box` ((40 − 2×1 de hairline − 20) / 2
// = 9) sob o `padding-top` de 6; no menu é o padding do cabeçalho
// (`estiloDoTopo`). Teste trava a conta.
export const TAMANHO_DO_BOTAO_DO_TOPO = 20
export const BORDA_DO_CARTAO = 1
export const RESPIRO_DO_TOPO = Object.freeze({ cima: 6, direita: 9, baixo: 4, esquerda: 16 })
// Tetos de rolagem interna: a régua mostra no máximo 5 tiles e o menu
// condensado no máximo 7 linhas; o resto rola por dentro (scrollbar fina).
export const MAX_TILES_VISIVEIS = 5
export const MAX_LINHAS_VISIVEIS_NO_MENU = 7
// A linha condensada: `py-1` (8) + 13px × 1.33 de line-height ≈ 26px.
export const ALTURA_DA_LINHA_DO_MENU = 26

export function alturaMaximaDaListaDaRegua() {
  return MAX_TILES_VISIVEIS * LADO_DO_TILE_DA_REGUA + (MAX_TILES_VISIVEIS - 1) * GAP_ENTRE_TILES_DA_REGUA
}

export function alturaMaximaDaListaDoMenu() {
  return MAX_LINHAS_VISIVEIS_NO_MENU * ALTURA_DA_LINHA_DO_MENU
}

export function larguraDoCartaoCondensado(larguraMaxima) {
  const faixa = Number(larguraMaxima) || 0
  return Math.min(LARGURA_MAXIMA_DO_CARTAO, Math.max(PISO_DO_CARTAO_CONDENSADO, faixa))
}

// `null` (sem medida) = cabe: o menu segue o conteúdo como sempre coube.
export function cabeMenuNaFaixa(larguraMaxima) {
  if (larguraMaxima === null || larguraMaxima === undefined) return true
  return Number(larguraMaxima) >= PISO_DO_CARTAO_CONDENSADO
}

// Chevrons nativos (`chevron-left`/`-right`, Iconsax `arrow-left-2`/`-right-2`,
// criados para cá): expandir a régua no menu sobreposto / recolher de volta.
export const ICONE_DE_EXPANDIR = 'chevron-left'
export const ICONE_DE_RECOLHER = 'chevron-right'
// O minimizar é pequeno e discreto no canto do cabeçalho.
export const TAMANHO_DO_ICONE_DO_TOPO = 14
// Ícone do módulo na linha condensada — o mesmo 16px do tile mini do card.
export const TAMANHO_DO_ICONE_DA_LINHA = 16
